<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Gross Profit Report</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content ref="contentDiv">
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <v-flex xs4 sm2>
            <v-text-field
              label="Sales Order No"
              v-model="txtSalesOrderNo"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <v-text-field
              label="Email"
              v-model="txtEmail"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <v-select
              :items="profitStatuses"
              label="Profit Status"
              v-model="cboProfitStatus"
            ></v-select>
          </v-flex>
          <v-flex xs6 sm2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="dtPicker1"
              :nudge-right="40"
              :return-value.sync="date1"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date1"
                label="Payment Date from"
                prepend-icon="event"
                clearable
                readonly
              ></v-text-field>
              <v-date-picker v-model="date1" no-title scrollable @input="$refs.menu1.save(date1)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 sm2>
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              v-model="dtPicker2"
              :nudge-right="40"
              :return-value.sync="date2"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date2"
                label="Payment Date to"
                prepend-icon="event"
                clearable
                readonly
              ></v-text-field>
              <v-date-picker v-model="date2" no-title scrollable @input="$refs.menu2.save(date2)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 sm1>
            <v-btn
              outline
              block
              @click="getReport(txtEmail, txtSalesOrderNo, cboProfitStatus, date1, date2)"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm1>
            <v-btn
              outline
              block
              @click="getReport(txtEmail, txtSalesOrderNo, cboProfitStatus, date1, date2, '', 0, 'csv')"
            >
              CSV
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="report"
              hide-actions
              class="elevation-1"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center subheading font-weight-bold">
                    Sales Order No
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Invoice No
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Type
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Payment Methods
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Payment Status
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Payment Date Time
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Delivery Status
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Tracking Nos
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Total Weight (Kg)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Total Sales (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Total Voucher (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Delivery Cost (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Total Payment (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Branch Sales (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Branch Cost (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Collected Shipping Cost for branches (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Real Shipping Cost for branches (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Seller Fee Received (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Payment Fee Received (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Real Payment Fee (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Payment Commission (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Extra Cost (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Profit (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Profit Status
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Branch Cost in CNY
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Branch Cost in Other Currency (USD)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Cost Funded by HQ (USD)
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :class="(props.index % 2 === 0 ? 'row1' : 'row2')">
                  <td class="text-xs-center"><router-link :to="'/order/' + props.item.salesOrderNo" target="_blank" class="white--text">{{ props.item.salesOrderNo }}</router-link></td>
                  <td class="text-xs-center">{{ props.item.invoiceNo }}</td>
                  <td class="text-xs-center">{{ props.item.type | allCaps }}</td>
                  <td class="text-xs-center">
                    <span v-for="methodId in props.item.paymentMethodIds.split(' ')" :class="(methodId.substring(0, 12) === 'BANKTRANSFER' && methodId.length > 12 ? 'amber--text' : '') + ' mr-3'" :key="methodId">
                      {{ methodId }}
                    </span>
                  </td>
                  <td :class="'text-xs-center font-weight-bold ' + (props.item.paymentStatus === 'chargeback' ? 'red--text' : (props.item.paymentStatus === 'paid' || props.item.paymentStatus === 'credit' ? 'green--text' : 'grey--text'))">{{ props.item.paymentStatus | allCaps }}</td>
                  <td class="text-xs-center">{{ props.item.paidDateTime | formatDate('DD-MM-YYYY HH:mm:ss', profile.gmtTimezone) }}</td>
                  <td :class="'text-xs-center font-weight-bold ' + (props.item.deliveryStatus === 'sent' || props.item.deliveryStatus === 'delivered' ? 'green--text' : 'grey--text')">{{ props.item.deliveryStatus | allCaps }}</td>
                  <td class="text-xs-center">{{ props.item.trackingNos }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalWeight) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalSalesInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalVoucherInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.deliveryCostInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalPaymentInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.branchSalesInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.branchCostInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.branchShippingCostInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.branchRealShippingCostInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.sellerFeeInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.paymentFeeReceivedInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.paymentRealFeeInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.paymentCommissionInBase) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.extraCostInBase) }}</td>
                  <td :class="'text-xs-center font-weight-bold ' + (props.item.profitInBase > 0 ? 'green--text' : 'red--text')">{{ formatPrice(props.item.profitInBase) }}</td>
                  <td :class="'text-xs-center font-weight-bold ' + (props.item.profitStatus === 'complete' ? 'green--text' : 'grey--text')">{{ props.item.profitStatus | allCaps }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.branchCostInCNY) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.branchCostInOtherCurrency) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.costPriceFundedByHQInBase) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 sm3 class="text-xs-left">
            <div>Total Branch Cost in CNY: <span class="subheading font-weight-bold">RMB {{ formatPrice(totalBranchCostInCNY) }}</span></div>
            <div>Total Branch Sales: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(totalBranchSales) }}</span></div>
            <div>Total Sales: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(totalSales) }}</span></div>
            <div>Total Shipping Cost: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(totalShippingCost) }}</span></div>
            <div>Total Voucher: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(totalVoucher) }}</span></div>
            <div>Total Chargeback: <span class="subheading font-weight-bold red--text">{{ def.currency.sign + formatPrice(totalChargeback) }}</span></div>
            <div>Total Gross Profit: <span :class="'subheading font-weight-bold ' + (totalProfit > 0 ? 'green--text' : 'red--text')">{{ def.currency.sign + formatPrice(totalProfit) }}</span></div>
            <div v-if="expenses && expenses.length > 0" class="mt-3">
              <strong>Expenses:</strong>
              <ul>
                <li v-for="expense in expenses" :key="expense.branchName">
                  {{ expense.branchName }}:
                  <span class="subheading font-weight-bold red--text">{{ def.currency.sign + formatPrice(expense.totalAmountInBase) }}</span>
                </li>
              </ul>
            </div>
          </v-flex>
          <v-flex xs12 sm3 class="text-xs-center pt-3">
            Showing {{ listOffset + 1 }} - {{ listOffset + report.length }} of {{ listTotal }}
          </v-flex>
          <v-flex sm3 xs6>
            <v-btn
              block
              outline
              :disabled="listOffset <= 0"
              @click="getReport(txtEmail, txtSalesOrderNo, cboProfitStatus, date1, date2, '', (listOffset-listLimit <= 0 ? 0 : listOffset-listLimit))"
            >
              Prev
            </v-btn>
          </v-flex>
          <v-flex sm3 xs6>
            <v-btn
              block
              outline
              :disabled="listOffset + listLimit >= listTotal"
              @click="getReport(txtEmail, txtSalesOrderNo, cboProfitStatus, date1, date2, '', listOffset+listLimit)"
            >
              Next
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import downloadjs from 'downloadjs'
import axios from 'axios'
import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      user: null,
      drawer: false,
      loading: false,
      txtSalesOrderNo: this.$route.query.order_no || '',
      txtEmail: this.$route.query.email || '',
      cboProfitStatus: this.$route.query.status || '',
      profitStatuses: ['', 'pending', 'partial', 'complete'],
      date1: this.$route.query.date1 || moment().format('YYYY-MM-01'),
      date2: this.$route.query.date2 || moment().format('YYYY-MM-DD'),
      dtPicker1: false,
      dtPicker2: false,
      report: [],
      listLimit: 10,
      listOffset: 0,
      listTotal: 0,
      totalBranchCostInCNY: 0,
      totalSales: 0,
      totalBranchSales: 0,
      totalVoucher: 0,
      totalHQFund: 0,
      totalShippingCost: 0,
      totalChargeback: 0,
      totalProfit: 0,
      sellers: [],
      expenses: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getReport(this.txtEmail, this.txtSalesOrderNo, this.cboProfitStatus, this.date1, this.date2)
    this.disableBottomDetector()
  },

  methods: {
    getReport: function (email = '', orderNo = '', profitStatus = '', date1 = '', date2 = '', sort = '', offset = 0, format = 'json') {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true

        // clean parameters
        if (!date1) {
          date1 = ''
        }
        if (!date2) {
          date2 = ''
        }

        // format time
        if (date1.length > 0) {
          date1 = date1 + ' 00:00:00'
        }
        if (date2.length > 0) {
          date2 = date2 + ' 23:59:59'
        }

        axios.get(process.env.VUE_APP_API_ROOT + '/v1/report/profit?email=' + email + '&order_no=' + orderNo + '&profit_status=' + profitStatus + '&min_paid_datetime=' + date1 + '&max_paid_datetime=' + date2 + '&sort=' + sort + '&offset=' + offset + '&format=' + format)
          .then(resp => {
            _this.loading = false
            if (format === 'json') {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                _this.report = resp.data.data
                _this.sellers = resp.data.sellers
                _this.listLimit = resp.data.limit
                _this.listOffset = resp.data.offset
                _this.listTotal = resp.data.total
                _this.totalBranchCostInCNY = resp.data.totalBranchCostInCNY
                _this.totalSales = resp.data.totalSalesInBase
                _this.totalBranchSales = resp.data.totalBranchSalesInBase
                _this.totalVoucher = resp.data.totalVoucherInBase
                _this.totalHQFund = resp.data.totalCostInBaseFundedByHQ
                _this.totalShippingCost = resp.data.totalShippingCostInBase
                _this.totalChargeback = resp.data.totalChargebackInBase
                _this.totalProfit = resp.data.totalProfitInBase
                _this.expenses = resp.data.expenses
              } else {
                console.log('unable to load report: ' + resp.data.message)
              }
            } else {
              downloadjs(resp.data, 'report.' + format.toLowerCase(), resp.headers['content-type'])
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>
